import React, { ForwardRefRenderFunction } from "react";
//#region types
import { FormHandles, GenericFormSection } from "models/propTypes/genericFormProps";
import { InvoiceFormTypes } from "models/formTypes";
import { TranslationKeys } from "translations";
import { FormEnums } from "models/enums";
import { QuotationPreviewFormProps } from "models/propTypes/quotationPropTypes";
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { FormFieldConstants } from "utils/constants";
//#endregion
//#region components
import { GenericForm } from "components/common";
import useQuotationSendMailFormFields from "./useSendMailFormFields";
//#endregion
import { EnumHelper, LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const QuotationPreviewForm: ForwardRefRenderFunction<FormHandles, QuotationPreviewFormProps> = (props, ref) => {
  const {
    serialNumber: invoiceId,
    customerId,
    mailForm,
    serialNumberTemplateValueDisplayText,
    onNotesChangeHandler,
    isDraft,
  } = props;

  const sendMailFields = useQuotationSendMailFormFields(
    customerId ?? 0,
    serialNumberTemplateValueDisplayText,
    invoiceId,
    mailForm,
    true,
    FormFieldConstants.Invoice.QuotationPreview.Loading
  );

  const fields: GenericFormSection<InvoiceFormTypes.QuotationPreview>[] = [
    {
      label: TranslationKeys.Invoice.SendAs,
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      innerFields: {
        sendType: {
          label: " ",
          type: FormEnums.FormFieldType.CHOICE,
          extraProps: {
            items: EnumHelper.getNumericItemValues(WintSuperkollAPIModel.InvoiceSendMethod)
              .filter((s) => s !== WintSuperkollAPIModel.InvoiceSendMethod.Print)
              .map((key) => {
                return {
                  id: Number(key),
                  value: LocalizationHelperInstance.getFormattedMessage(`Invoice.SendType_${key}`),
                };
              }),
          },
        },
      },
    },
    {
      label: " ",
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      innerFields: {
        sendMail: {
          label: " ",
          type: FormEnums.FormFieldType.SUBFORM,
          innerFields: sendMailFields,
        },
      },
      className: cssExports.noTitle,
      hidden: (values: InvoiceFormTypes.Preview) => values.sendType !== WintSuperkollAPIModel.InvoiceSendMethod.Email,
    },
    {
      label: TranslationKeys.Invoice.MessagesAndAttachments,
      type: FormEnums.FormSectionType.FIELDGROUPSECTION,
      hidden: !isDraft,
      innerFields: {
        notes: {
          label: TranslationKeys.Common.Message,
          type: FormEnums.FormFieldType.TEXTAREA,
          descriptionText: TranslationKeys.Invoice.MessageDescription,
          onChangeHandler: onNotesChangeHandler,
        },
        attachments: {
          label: TranslationKeys.Common.Attachments,
          type: FormEnums.FormFieldType.FILEUPLOADER,
          descriptionText: TranslationKeys.Invoice.AttachmentsDescription,
        },
      },
    },
  ];

  return <GenericForm<InvoiceFormTypes.QuotationPreview> formRef={ref} {...props} fields={fields} hideSuccess />;
};

export default React.forwardRef(QuotationPreviewForm);
